import { render, staticRenderFns } from "./WeeklyTestMarkSheetRecord.vue?vue&type=template&id=09c270d7&scoped=true"
import script from "./WeeklyTestMarkSheetRecord.vue?vue&type=script&lang=js"
export * from "./WeeklyTestMarkSheetRecord.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTestMarkSheetRecord.vue?vue&type=style&index=0&id=09c270d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c270d7",
  null
  
)

export default component.exports